import { render } from "./ReceiptProjectView.vue?vue&type=template&id=457c106c&scoped=true"
import script from "./ReceiptProjectView.vue?vue&type=script&lang=js"
export * from "./ReceiptProjectView.vue?vue&type=script&lang=js"

import "./ReceiptProjectView.vue?vue&type=style&index=0&id=457c106c&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457c106c"]])

export default __exports__